export default "__VITE_ASSET__cd1b229a__"